import { render, staticRenderFns } from "./CommentDrawer.vue?vue&type=template&id=15289a2a&scoped=true"
import script from "./CommentDrawer.vue?vue&type=script&lang=js"
export * from "./CommentDrawer.vue?vue&type=script&lang=js"
import style0 from "./CommentDrawer.vue?vue&type=style&index=0&id=15289a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15289a2a",
  null
  
)

export default component.exports